import React from 'react'

/**
 * Lightweight surface card — consistent shadow, radius and padding.
 * Accepts any div props plus a `style` object that merges with defaults.
 */
export default function Card(props) {
    const { style, children, ...rest } = props
    return (
        <div {...rest} style={{ ...defaultStyles, ...style }}>
            {children}
        </div>
    )
}

const defaultStyles = {
    backgroundColor: '#ffffff',
    borderRadius: 10,
    boxShadow: '0 2px 12px rgba(0,0,0,0.07)',
    padding: 16,
    margin: 0,
}
